// This is the standard web chat configuration object. You can modify these values with the embed code for your
// own assistant if you wish to try this example with your assistant. You can find the documentation for this at
// https://web-chat.global.assistant.watson.cloud.ibm.com/docs.html?to=api-configuration#configurationobject.

// integrationID is the watsonx Assistant integration id found from the web credentials
// region is the region where watsonx assistant is hosted
// serviceInstanceID is from the URL once the service is deployed
// subscriptionID is left as null unless requried

const config = {
  //old
  //integrationID: '574a12fd-4417-4e09-b9ee-3af1ea84b584',
  //serviceInstanceID: 'e6af0f22-fcb5-4751-930c-0391a3fa9950',

  // integrationID: 'faccdd59-4c9a-403b-8ec7-f87d5a223360',    //draft - dev
  integrationID: 'ae9a20fe-6691-44fe-b5cb-395a3fa687c5', //live - staging / production
  serviceInstanceID: '020f84d4-ede9-4b68-8895-c7372f3f4cb4',
  region: 'wxo-ca-tor',
  subscriptionID: null,
}

// Known vehicle types - Update to relevant year when url known
const VEHICLE_TYPES = {
  OUTLANDER: 'outlander',
  ECLIPSE: 'eclipse-cross',
}

// included url examples
// - /en/vehicles/eclipse-cross
// - /en/vehicles/eclipse-cross/123
// - /fr/vehicules/eclipse-cross
// - /fr/vehicules/eclipse-cross/123
// excluded url examples
// - /en/vehicles/eclipse-cross-2025
// - /fr/vehicules/eclipse-cross-2025
// - /en/vehicles/eclipse-cross-2025/123
// - /fr/vehicules/eclipse-cross-2025/123

// URL configuration for determining vehicle context
const VEHICLE_URL_CONFIG = [
  {
    urls: {
      includes: [
        `/en/vehicles/${VEHICLE_TYPES.OUTLANDER}`,
        `/fr/vehicules/${VEHICLE_TYPES.OUTLANDER}`,
      ],
      excludes: [],
    },
    vehicleType: VEHICLE_TYPES.OUTLANDER,
  },
  {
    urls: {
      includes: [`/en/vehicles/${VEHICLE_TYPES.ECLIPSE}`, `/fr/vehicules/${VEHICLE_TYPES.ECLIPSE}`],
      excludes: [
        `/en/vehicles/${VEHICLE_TYPES.ECLIPSE}-2025`,
        `/fr/vehicules/${VEHICLE_TYPES.ECLIPSE}-2025`,
      ],
    },
    vehicleType: VEHICLE_TYPES.ECLIPSE,
  },
]

export { config, VEHICLE_TYPES, VEHICLE_URL_CONFIG }
